document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".gem-carousel").forEach((root) => {

    const track = root.querySelector(".gem-track");
    const prev  = root.querySelector(".gem-prev");
    const next  = root.querySelector(".gem-next");
    const bar   = root.querySelector(".gem-scrollbar");
    const thumb = root.querySelector(".gem-thumb");

    if (!track || !prev || !next || !bar || !thumb) return;

    /* -------------------------------
       画像ドラッグ防止
    --------------------------------*/
    track.querySelectorAll("a,img").forEach(el=>{
      el.setAttribute("draggable","false");
      el.addEventListener("dragstart",e=>e.preventDefault());
    });

    /* -------------------------------
       共通計算
    --------------------------------*/
    const gapPx = () =>
      parseFloat(getComputedStyle(track).gap || 0) || 0;

    const step = () => {
      const c = track.querySelector(".gem-card");
      if(!c) return 0;
      return c.getBoundingClientRect().width + gapPx();
    };

    const setSnap = on =>
      track.style.scrollSnapType = on ? "x mandatory" : "none";

    /* -------------------------------
       ボタン
    --------------------------------*/
    prev.addEventListener("click", () =>
      track.scrollBy({ left:-step(), behavior:"smooth" })
    );

    next.addEventListener("click", () =>
      track.scrollBy({ left: step(), behavior:"smooth" })
    );

    /* ============================================================
   Drag + inertia（柔らかさMAX版・カチッ感消し）
============================================================ */

let down=false, dragging=false, pointerId=null;
let startX=0,startY=0,startScroll=0;
let lastX=0,lastT=0;

let vx=0,vxSmooth=0,rafId=null;
let lastDragEndAt=0;

/* ===== 調整パラメータ ===== */

const DRAG_SPEED=1.45;

// 慣性（滑り感）
const FRICTION = 0.96

// 吸着（柔らかさ）
const ATTRACTION=0.06;
const DAMPING=0.85;

// 停止判定（最後の硬さ対策）
const STOP_V=0.045;
const STOP_DIST=0.65;

const MAX_VELOCITY=80;

const DRAG_START_PX=10;
const HORIZONTAL_RATIO=1.15;
const CLICK_BLOCK_MS=80;

/* ========================= */

const stopInertia=()=>{
  if(rafId) cancelAnimationFrame(rafId);
  rafId=null;
};

const startInertia=()=>{
  stopInertia();

  const s=step();
  if(!s) return;

  const tick=()=>{
    const x=track.scrollLeft;
    const target=Math.round(x/s)*s;
    const dist=target-x;

    // ① 慣性（少し強め）
    vxSmooth*=FRICTION;

    // ② 柔らか吸着（弱めにして丸いカーブ）
    vxSmooth+=dist*ATTRACTION;
    vxSmooth*=DAMPING;

    const nextX=x+vxSmooth;

    // ③ オーバーシュート防止（でも急停止しない）
    if((x<target&&nextX>target)||(x>target&&nextX<target)){
      track.scrollLeft=target;
      setSnap(true);
      rafId=null;
      return;
    }

    track.scrollLeft=nextX;

    // ④ 自然停止（かなり緩く）
    if(Math.abs(dist)<STOP_DIST && Math.abs(vxSmooth)<STOP_V){
      track.scrollLeft=target;
      setSnap(true);
      rafId=null;
      return;
    }

    rafId=requestAnimationFrame(tick);
  };

  rafId=requestAnimationFrame(tick);
};

track.addEventListener("pointerdown",e=>{
  if(e.pointerType==="mouse"&&e.button!==0) return;

  down=true;
  dragging=false;
  pointerId=e.pointerId;

  startX=e.clientX;
  startY=e.clientY;
  startScroll=track.scrollLeft;

  lastX=e.clientX;
  lastT=performance.now();

  vx=0;
  vxSmooth=0;

  stopInertia();
});

track.addEventListener("pointermove",e=>{
  if(!down||(pointerId!==null&&e.pointerId!==pointerId))return;

  const dx0=e.clientX-startX;
  const dy0=e.clientY-startY;

  if(!dragging){
    const absX=Math.abs(dx0);
    const absY=Math.abs(dy0);

    if(absX>=DRAG_START_PX&&absX>=absY*HORIZONTAL_RATIO){
      dragging=true;
      setSnap(false);
      try{track.setPointerCapture(e.pointerId);}catch{}
      track.classList.add("gem-dragging");
    }else return;
  }

  e.preventDefault();

  const moveX=(startX-e.clientX)*DRAG_SPEED;
  track.scrollLeft=startScroll+moveX;

  const now=performance.now();
  const dt=Math.max(8,now-lastT);
  const inst=(lastX-e.clientX)/dt*16;

  vx=Math.max(-MAX_VELOCITY,Math.min(MAX_VELOCITY,inst*DRAG_SPEED));

  // ★ここを柔らかく（0.75→0.85）
  vxSmooth=vxSmooth*0.85+vx*0.15;

  lastX=e.clientX;
  lastT=now;

},{passive:false});

const endDrag=e=>{
  if(!down)return;
  down=false;

  if(dragging){
    track.classList.remove("gem-dragging");
    try{track.releasePointerCapture(e.pointerId);}catch{}

    lastDragEndAt=performance.now();
    startInertia();
  }else{
    setSnap(true);
  }

  dragging=false;
  pointerId=null;
};

track.addEventListener("pointerup",endDrag);
track.addEventListener("pointercancel",endDrag);

track.querySelectorAll(".gem-card").forEach(card=>{
  card.addEventListener("click",ev=>{
    if(performance.now()-lastDragEndAt<CLICK_BLOCK_MS){
      ev.preventDefault();
      ev.stopPropagation();
    }
  },true);
});


    /* ============================================================
       Scrollbar thumb
    ============================================================ */

    const updateThumb=()=>{
      const max=track.scrollWidth-track.clientWidth;
      const barW=bar.clientWidth;

      if(max<=0){
        thumb.style.width=barW+"px";
        thumb.style.left="0px";
        return;
      }

      const ratio=track.clientWidth/track.scrollWidth;
      const thumbW=Math.max(36,barW*ratio);
      const left=(track.scrollLeft/max)*(barW-thumbW);

      thumb.style.width=thumbW+"px";
      thumb.style.left=left+"px";
    };

    track.addEventListener("scroll",()=>requestAnimationFrame(updateThumb));
    new ResizeObserver(updateThumb).observe(track);
    updateThumb();

    /* thumb drag */
    let tDown=false,tStartX=0,tStartLeft=0,tPointerId=null;

    const endThumb=()=>{
      if(!tDown) return;
      tDown=false;
      tPointerId=null;
      settleSpring();
    };

    thumb.addEventListener("pointerdown",e=>{
      tDown=true;
      tPointerId=e.pointerId;
      tStartX=e.clientX;
      tStartLeft=parseFloat(getComputedStyle(thumb).left)||0;

      setSnap(false);
      try{thumb.setPointerCapture(e.pointerId);}catch{}
      e.preventDefault();
    });

    thumb.addEventListener("pointermove",e=>{
      if(!tDown || e.pointerId!==tPointerId) return;

      const max=track.scrollWidth-track.clientWidth;
      const barW=bar.clientWidth;
      const thumbW=thumb.getBoundingClientRect().width;

      const dx=e.clientX-tStartX;
      const newLeft=Math.min(barW-thumbW,Math.max(0,tStartLeft+dx));

      track.scrollLeft=(newLeft/(barW-thumbW))*max;
      e.preventDefault();
    },{passive:false});

    thumb.addEventListener("pointerup",endThumb);
    thumb.addEventListener("pointercancel",endThumb);
    thumb.addEventListener("lostpointercapture",endThumb);
    thumb.addEventListener("pointerleave",endThumb);

    window.addEventListener("blur",endThumb);
    window.addEventListener("mouseup",endThumb);
    window.addEventListener("touchend",endThumb,{passive:true});
  });
});
